import {useDebugValue, useState} from 'react';

import {useInitialization} from '../../../hooks';
import {getSearchCookies} from '../../../utils';

const initialSearchCookies = {
    destinationValues: {},
    datesValues: {},
    guestsValues: {}
};

function useSearchCookies() {
    const [
        searchCookies,
        setSearchCookies
    ] = useState(initialSearchCookies);

    function updateSearchCookies(nextSearchCookies) {
        setSearchCookies(nextSearchCookies);
    }

    useInitialization(function initializeSearchCookies() {
        updateSearchCookies(getSearchCookies());
    });

    const result = {
        searchCookies
    };

    useDebugValue(result);

    return result;
}

export {useSearchCookies};
